import { render, staticRenderFns } from "./saleSummary.vue?vue&type=template&id=5f96fd76&scoped=true"
import script from "./saleSummary.vue?vue&type=script&lang=js"
export * from "./saleSummary.vue?vue&type=script&lang=js"
import style0 from "./saleSummary.vue?vue&type=style&index=0&id=5f96fd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96fd76",
  null
  
)

export default component.exports